// extracted by mini-css-extract-plugin
module.exports = {"ActingAs":"q7z7Id","Link":"_8AQbEE"};